import * as React from "react";
import { getID } from "../../../utils/IdGenerator";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheckSquare, faMinusSquare, faSquare } from '@fortawesome/free-regular-svg-icons';

type Props = {
	name: string;
	value: string | number;
	checked: boolean;
	onChange: (checked: boolean) => void;
	required?: boolean;
	indeterminate?: boolean;
	label: string | JSX.Element;
	disabled?: boolean;
};

type State = {
	id: string;
};

/**
 * A checkbox which supports an indeterminate state.
 */
class Checkbox extends React.PureComponent<Props, State> {
	private readonly textInput: React.RefObject<HTMLInputElement> = React.createRef();
	constructor(props: Props) {
		super(props);
		this.state = {
			id: getID()
		};
		this.textInput = React.createRef();
	}

	public componentDidMount() {
		this.textInput.current!.indeterminate = !!this.props.indeterminate;
	}

	public componentDidUpdate(prevProps: Props) {
		const b = !!this.props.indeterminate;
		if (prevProps.indeterminate !== b) {
			this.textInput.current!.indeterminate = b;
		}
	}

	public focus = () => this.textInput.current!.focus();

	public render() {
		return (
			<div className="checkbox-control checkbox__multiple-choice">
				<input
					id={this.state.id}
					name={this.props.name}
					type="checkbox"
					value={this.props.value}
					checked={this.props.checked}
					onChange={e => this.props.onChange(e.target.checked)}
					required={this.props.required}
					disabled={this.props.disabled}
					ref={this.textInput}
				/>
				<label htmlFor={this.state.id}>
					<FontAwesomeIcon icon={faSquare} size="lg" className="checkbox-control empty" />
					<FontAwesomeIcon icon={faMinusSquare} size="lg" className="checkbox-control indeterminate" />
					<FontAwesomeIcon icon={faCheckSquare} size="lg" className="checkbox-control checked" />

					{typeof this.props.label === "string" ? (
						<span>{this.props.label}</span>
					) : (
						this.props.label
					)}
				</label>
			</div>
		);
	}
}

export default Checkbox;
